import { Analytics } from '@easy-expense/analytics-client';
import { useIsAdminRole } from '@easy-expense/data-firestore-client';
import { getTranslation } from '@easy-expense/intl-client';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import { getReportDisplayStatus } from '@easy-expense/utils-client';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ReportMaterialTable } from '../Report/ReportMaterialTable.component';
import { useReportsRows } from '../Report/useReportTableRows';
import { CloseButton } from '../Shared/CloseButton.component';

export const ReviewReports: React.FC = () => {
  const navigate = useNavigate();
  const isAdmin = useIsAdminRole();
  const allReportRows = useReportsRows();

  const reviewReportKeys = React.useMemo(
    () =>
      allReportRows
        .filter((report) => {
          const status = getReportDisplayStatus(report);
          return status === 'pending' || status === 'needsReimbursement';
        })
        .map((report) => report.key),
    [allReportRows],
  );

  React.useEffect(() => {
    Analytics.track('approval_queue_viewed', {
      role: isAdmin ? 'admin' : 'manager',
      queueType: 'reports',
      pendingCount: reviewReportKeys.length,
      platform: 'web',
    });
  }, [isAdmin, reviewReportKeys.length]);

  return (
    <Layout.Row px={24} style={{ height: '100vh', width: '100%' }}>
      <Spacer.Flex />
      <Layout.Column style={{ height: '100vh', minWidth: 1100 }}>
        <Layout.Row py align>
          <OpenSans.Primary weight="bold-700" size={32}>
            {getTranslation('Review Reports')}
          </OpenSans.Primary>
        </Layout.Row>

        <ReportMaterialTable reportKeys={reviewReportKeys} />
      </Layout.Column>
      <Spacer.Flex />
      <CloseButton onClose={() => navigate('/reports')} />
    </Layout.Row>
  );
};
